module.exports = __webpack_public_path__ + "media/video-bg.f8d96297.mp4";